<template>
  <WithPaginationAndFilters
    v-slot="{ data, sortChange, filterChange }"
    class="apps-table"
    :is-loading="isLoading"
    :data="apps"
  >
    <ElTable
      stripe
      :data="data"
      :row-style="{ cursor: 'pointer' }"
      @sort-change="sortChange"
      @filter-change="filterChange"
      @row-click="goToApp"
    >
      <ElTableColumn
        v-slot="{ row: app }"
        min-width="180"
        prop="name"
        :label="$t('APPS.LIST.NAME')"
      >
        <img
          :key="app.name"
          :src="app.icon"
          :alt="app.name"
          width="30"
          height="30"
          class="apps-table__app-icon"
        />
        <span>{{ app.name }}</span>
        <EsraRatingIndicator :app="app" />
        <span
          v-if="app.hasUnreadSupport"
          class="apps-table__support-unread-dot"
        />
      </ElTableColumn>

      <ElTableColumn
        v-slot="{ row: app }"
        min-width="100"
        column-key="published"
        :filters="appsFilters"
        :label="$t('APPS.LIST.STATUS')"
      >
        <span
          v-if="
            hasPublish(app.packageName) || hasChangeAppInfo(app.packageName)
          "
        >
          {{ getAppState(app.published) }}
        </span>
        <span v-else>—</span>
      </ElTableColumn>

      <ElTableColumn
        v-slot="{ row: app }"
        prop="price"
        sortable
        :label="$t('APPS.LIST.PRICE')"
      >
        <span v-if="hasPublish(app.packageName)">
          {{ priceLabel(app.price, $t('RIALS'), $t('FREE')) }}
          <span v-show="app.haveIap" class="icon-coin" />
        </span>
        <span v-else>—</span>
      </ElTableColumn>

      <ElTableColumn
        v-slot="{ row: app }"
        :label="$t('APPS.LIST.INSTALLED')"
        prop="installsCount"
        sortable
        :sort-method="installsCountSortMethod"
      >
        <span dir="ltr">{{ app.installsCount || '-' }}</span>
      </ElTableColumn>

      <ElTableColumn
        v-slot="{ row: app }"
        :label="$t('APPS.LIST.RATING')"
        :width="250"
        prop="rate"
        sortable
      >
        <AppRate :count="app.reviewsCount" :rate="app.rate" />
      </ElTableColumn>
    </ElTable>
  </WithPaginationAndFilters>
</template>

<script>
import WithPaginationAndFilters from '@@/common/paginations/WithPaginationAndFilters';
import AppRate from './AppRate';
import EsraRatingIndicator from './EsraRatingIndicator';
import { needsEsraRating } from './esraRating';
import appState from '@/mixins/appState';
import permissions from '@/mixins/permissions';
import { label as priceLabel } from '@/utils/number';

export default {
  name: 'AppsTable',
  components: { WithPaginationAndFilters, AppRate, EsraRatingIndicator },
  mixins: [appState, permissions],

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    apps: {
      type: Array,
      required: true,
    },
  },

  computed: {
    appsFilters() {
      return Object.keys(this.appStates).map(key => ({
        value: key,
        text: this.$t(this.appStates[key]),
      }));
    },
  },

  methods: {
    priceLabel,
    installsCountSortMethod(row1, row2) {
      const installsCount1 = row1.installsCount || 0;
      const installsCount2 = row2.installsCount || 0;
      return Number(installsCount1) - Number(installsCount2);
    },
    goToApp(app) {
      const { packageName } = app;
      const name = needsEsraRating(app) ? 'app-info' : 'apps-view';

      this.$router
        .push({ name, params: { packageName } })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.apps-table__app-icon {
  margin-right: $global-margin;

  @include rtl() {
    margin-right: 0;
    margin-left: $global-margin;
  }
}

.apps-table__support-unread-dot {
  display: inline-block;
  width: rem-calc(10px);
  height: rem-calc(10px);
  min-width: rem-calc(10px);
  border-radius: 50%;
  background-color: $lb-color-alert;
  margin-left: $global-margin / 2;

  @include rtl() {
    margin-left: 0;
    margin-right: $global-margin / 2;
    margin-bottom: $global-margin / 2;

  }
}
</style>
